<template>
  <div class="d-flex align-items-center" v-if="msg">
    <div class="img_cont">
      <font-awesome-icon
        v-if="msg.userType == 'admin' || msg.userType == 'system'"
        :icon="['fas', 'user']"
        class="rounded-circle user_img_blank"
      />
      <div v-else class="rounded-circle user_img">
        <div
          class="rounded-circle user_img_display"
          v-bind:style="{
            backgroundImage: 'url(' + msg.logoUrl + ')'
          }"
        ></div>
      </div>
    </div>
    <div class="user_info">
      <div class="d-flex">
        <span class="name">{{
          msg.userType == "admin"
            ? msg.adminName
            : msg.userType == "system"
            ? msg.userType.toUpperCase()
            : $store.state.displayNameCurrentChat
            ? $store.state.displayNameCurrentChat
            : otherInfo.displayname
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      required: true,
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.img_cont {
  position: relative;
  height: 30px;
  width: 30px;
  margin-right: 5px;
  .user_img_display {
    padding-bottom: 100%;
  }
  .user_img_blank {
    padding: 5px;
    height: 100%;
    width: 100%;
  }
}
.name {
  font-weight: bold;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  max-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
